export const hasMatchingDimensions = (
  itemLength: number | undefined,
  itemWidth: number | undefined,
  inputLength: number | null | undefined,
  inputWidth: number | null | undefined
): boolean => itemLength === inputLength && itemWidth === inputWidth;
